import React from "react"
import PropTypes from "prop-types"
import { Field } from "redux-form/immutable"

// Components
import GridToggleSelectField from "app/static/frontend/forms/components/GridToggleSelectField"

const BulkActionsAlignment = (props) => (
    <div className="bulk-actions-console-alignment-form" data-cy="bulk-actions-console-alignment-form">
        <Field
            allowNull={false}
            choices={props.alignmentTypes}
            className="bulk-actions-form-alignment-select"
            component={GridToggleSelectField}
            dropUp={false}
            multi={false}
            name="alignment_type"
        />
    </div>
)

BulkActionsAlignment.propTypes = {
    alignmentTypes: PropTypes.array,
}

export default BulkActionsAlignment
